import { Path } from 'path-parser';

export const routeImplementation = {
  getParams: (
    pathWithSlug: string,
    pathname: string
  ): Record<string, string> | null => {
    const path = Path.createPath<Record<string, string>>(pathWithSlug);
    return path.test(pathname);
  },
  shouldMatchRoute: (pathWithSlug: string, pathname: string): boolean => {
    return !!routeImplementation.getParams(pathWithSlug, pathname);
  },
  buildRoute: (
    pathWithSlug: string,
    params: Record<string, string>
  ): string => {
    const path = Path.createPath<Record<string, string>>(pathWithSlug);
    return path.build({ ...params });
  }
};
